import { render } from "./Form.vue?vue&type=template&id=d79c1060&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=d79c1060&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d79c1060"

export default script